import { APP_PERMISSIONS } from '@exam-management/permissions';
import { type AlertProps, Button, Flex } from '@shared/components';
import { useHasPermission } from '@shared/permissions';
import { useCallback } from 'react';

import { BaseAlert } from '../../components';
import { QSetListModalAction, useQSetListModal } from '../../providers';

// NOTE: ReturnType is declared here to make sure severity is string literal type
function getAlertProps(selectedQSetCount: number, handlePublish: () => void): Partial<AlertProps> {
  if (selectedQSetCount === 0) {
    return {
      children: 'เลือกชุดข้อสอบเพื่อเปลี่ยนสถานะ (สูงสุด 10 รายการ)',
      severity: 'info',
    };
  }

  if (selectedQSetCount > 10) {
    return {
      children: 'เลือกชุดข้อสอบได้สูงสุด 10 รายการ',
      severity: 'error',
    };
  }

  return {
    children: `เลือก ${selectedQSetCount} รายการ`,
    severity: 'info',
    action: (
      <Button size='small' color='secondary' variant='outlined' onClick={handlePublish}>
        Publish
      </Button>
    ),
  };
}

export default function ReviewedQSetListBanner() {
  const { selectedQSetIds, setAction } = useQSetListModal();
  const isPublishable = useHasPermission(APP_PERMISSIONS.EXAM.QSET.STATUS);

  const handlePublish = useCallback(() => {
    setAction(QSetListModalAction.QSET_PUBLISH);
  }, [setAction]);

  if (!isPublishable) {
    return null;
  }

  return (
    <Flex sx={{ padding: (theme) => theme.spacing(4), width: '100%' }}>
      <BaseAlert {...getAlertProps(selectedQSetIds.length, handlePublish)} />
    </Flex>
  );
}
